import { getTranslations } from "../i18n"
import { useLocale } from "../locale-context"

/**
 * Pure presentational content for the authenticated NotFound route. Lives in its
 * OWN file (no `AuthenticatedShell` import) so it stays import.meta-free and
 * Jest-testable; the page wrapper composes it with the shell in not-found.tsx.
 */
export function NotFoundContent() {
	const { locale } = useLocale()
	const t = getTranslations(locale).notFound
	return (
		<div data-testid="not-found" className="p-8 text-center">
			<h1 className="text-lg font-semibold">{t.title}</h1>
		</div>
	)
}
